import { render, staticRenderFns } from "./GRDChart.vue?vue&type=template&id=0844bc7c"
import script from "./GRDChart.vue?vue&type=script&lang=js"
export * from "./GRDChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports